'use strict';

var Modals = {
	DOWNLOAD_DIALOG: '#modal-download-dialog',
	ERROR_PROCESS: '#modal-error-process',
	ERROR_SIZE: '#modal-error-size',
	ERROR_WEIGHT: '#modal-error-weight',
	ERROR_TYPE: '#modal-error-type',
	ERROR_TIMEOUT: '#modal-error-timeout'
};

module.exports = Modals;
